import React from 'react';
import socketio from 'socket.io-client';
import { shopManagerApi } from 'configs';
import Cookies from 'js-cookie';


const socket = socketio.connect(shopManagerApi.replace('/v1', ''), {
  path: '/v1/socket/',
  auth: { token: Cookies.get('token') }
});

const SocketContext = React.createContext();

export { socket, SocketContext };
